import { render, staticRenderFns } from "./NotificationBadge.vue?vue&type=template&id=53a4eda8&scoped=true"
import script from "./NotificationBadge.vue?vue&type=script&lang=js"
export * from "./NotificationBadge.vue?vue&type=script&lang=js"
import style0 from "./NotificationBadge.vue?vue&type=style&index=0&id=53a4eda8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a4eda8",
  null
  
)

export default component.exports